import React from 'react';
import { TPitchId } from '../FeedSelect/IFeedSelect';
import TextEditor from '../TextEditor/TextEditor';
import CompaniesPageService from '@services/CompaniesPage.service';
import FeedSelect from '../FeedSelect/FeedSelect';
import INewFeed, { TNewFeed } from './INewFeed';
import { getAxiosErrorMessage, isAndroidDevice } from '@features/utils/functions';
import { pushNotify } from '@appComponents/Notification/Notification';

import * as style from './NewFeedStyles.module.scss'

export default class NewFeed extends React.PureComponent<INewFeed, TNewFeed> {
  editorRef: TextEditor;

  state: TNewFeed = {
    pitch_id: null,
    showBtn: false,
    isCompanyUpdate: false,
  };

  componentDidUpdate(prevProps: INewFeed) {
    if (this.props.isDiscussion !== prevProps.isDiscussion) {
      this.setState({ isCompanyUpdate: false });
      this.editorRef.setEditorEmpty();
    }
  }

  getButtonStatus = (showBtn: boolean) => {
    this.setState({ showBtn });
  }

  getSelectValue = (value: TPitchId) => {
    this.setState({ pitch_id: typeof value === 'number' ? value : null });
  }

  setCompanyUpdate = () => {
    this.setState({ isCompanyUpdate: !this.state.isCompanyUpdate });
  }

  publish = () => {
    const values = this.editorRef.sendValueToParent();
    const path = this.props.isDiscussion ? 'public' : 'private';

    const data = {
      message: values.message,
      pitch_id: this.state.pitch_id,
      parent_id: null,
      image_ids: values.imagesId,
      is_update: this.state.isCompanyUpdate,
    };

    CompaniesPageService.postFeed(data, path)
      .then((res) => {
        this.setState({ isCompanyUpdate: false, showBtn: false });
        this.props.updatePosts(res.data);
      }).catch((error) => {
        window.scrollTo(0, 0);
        pushNotify('error', getAxiosErrorMessage(error), 5000);
      });
  }

  render() {
    const disabledForAndroid = isAndroidDevice();
    return (
      <div className={style.newFeed}>
        {disabledForAndroid
          ? <span>
              <i>
                Due to technical issues, commenting is currently disabled for android
                devices, please use the desktop application instead.
              </i>
            </span>
          : <div className={style.feedTop}>
            <h5>Add a public update</h5>
            <div>
              <p>Topic: </p>
              <FeedSelect
                funding={this.props.funding}
                getSelectValue={this.getSelectValue}
                moreOptions={false}
                pitchId={this.props.pitchId}
                blockByPitchId={true}
              />
            </div>
          </div>
        }
        <TextEditor
          ref={(editor) => {this.editorRef = editor as TextEditor;}}
          setButtonStatus={this.getButtonStatus}
          avatar={this.props.profileAvatar}
          isOwner={this.props.isOwner}
          isCompanyUpdate={this.state.isCompanyUpdate}
          setCompanyUpdate={this.setCompanyUpdate}
          disabledForAndroid={disabledForAndroid}
        />
        {this.state.showBtn &&
          <button
            onClick={this.publish}
            className={style.publishBtn}
          >
            Publish
          </button>
        }
      </div>
    );
  }
}
